var map = {
	"./1.png": 5012,
	"./2.png": 23919,
	"./3.png": 1254,
	"./4.png": 94329,
	"./5.png": 97424,
	"./6.png": 50923,
	"./7.png": 29794,
	"./8.png": 76741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48925;